import { Row } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { subUrl } from "../../helper/globals";

export default function Breadcrumbs(props) {
  return (
    <div className="page-content">
      <div className="page-banner">
        <Row>
          <div className="desc-box">
            <h2>{props.title}</h2>
            <Breadcrumb className="breadcrumbs">
              <Breadcrumb.Item href={subUrl}>Home</Breadcrumb.Item>
              {props.route.map((e) => {
                return <Breadcrumb.Item href={e.url}>{e.text}</Breadcrumb.Item>;
              })}
            </Breadcrumb>
          </div>
        </Row>
      </div>
      <div className="margin-top">{props.content}</div>
    </div>
  );
}
